import { Box, } from "@mui/material";
import { usePage } from "../../contexts/PageProvider";

const Page = ({page}) => {
    const {pageData} = usePage();
    return (
        pageData &&
        <Box 
            className="page"
            sx={{
                padding: (pageData?.noPadding ? "0" : "2em"),
                overflowX: "hidden",
                overflowY: 'auto', 
                height: "100%", 
                width: "100%",
                maxHeight: "calc(100vh - 56px)"
            }}
        >
            {pageData?.title ? <h1>{pageData?.title}</h1> : null}
            {page}
        </Box>
    );
};

export default Page